(function ($) {

  const initializeLogoGridBlock = function ($block) {
    $('.wp-block-cite-wordpress-theme-logo-grid.logo-grid-carousel').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      centerMode: true,
      arrows: true,
      dots: false,
      fade: false,
      cssEase: 'linear',
      autoplay: false,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      swipeToSlide: true
    });
  }

  // Initialize each block on page load (front end).
  $(document).ready(function () {
    initializeLogoGridBlock();
  });


})(jQuery);

